<sharry-header></sharry-header>
<div class="cherry-meter">
  <div class="cherry-meter__hero">
    <div class="cherry-meter__hero__left">
      <h1
        class="baloo"
        sharryViewport="fade-in">
        <img
          width="90"
          height="110"
          sharryViewport="fade-in"
          src="https://media.sharry.land/app/images/ciliegiometro/ciliegiometro-animated.svg"
          alt="cherry" />
        {{ 'cherry-meter.hero.title' | i18next }}
      </h1>
      <p
        class="baloo"
        sharryViewport="fade-in-1">
        {{ 'cherry-meter.hero.desc' | i18next }}
      </p>
    </div>
    <div class="cherry-meter__hero__right">
      <img
        class="cherry-meter__hero__hero-image"
        src="https://media.sharry.land/app/images/cherry-meter/hero.png"
        sharryViewport="fade-in-2"
        alt="cherry-meter hero" />
    </div>
  </div>
  @if (userService.user$ | async; as user) {
    <ng-container
      [ngTemplateOutlet]="userHandlingTemplate"
      [ngTemplateOutletContext]="{ user: user }"></ng-container>
  } @else {
    <ng-container [ngTemplateOutlet]="userHandlingTemplate"></ng-container>
  }
  <ng-template
    #userHandlingTemplate
    let-user="user">
    <div
      class="cherry-meter__discount"
      sharryViewport="fade-in-1">
      <h3 class="baloo">{{ 'cherry-meter.cherries-discount' | i18next }}</h3>
      @if (user) {
        <button
          class="rounded sharry-big"
          mat-flat-button
          color="primary"
          (click)="openDiscountsModal()">
          {{ 'cherry-meter.view-discounts' | i18next }}
        </button>
      } @else {
        <a
          class="rounded sharry-big"
          mat-flat-button
          color="primary"
          [routerLink]="[]"
          [queryParams]="{ signup: true }">
          {{ 'cherry-meter.sign-up' | i18next }}
        </a>
      }
    </div>
    <div class="cherry-meter__gallery">
      <h3
        class="baloo"
        sharryViewport="fade-in">
        {{ 'cherry-meter.use-codes' | i18next }}
      </h3>
      <sharry-search-gallery sharryViewport="fade-in"></sharry-search-gallery>
    </div>
    <div class="cherry-meter__gradient-bg">
      <div class="cherry-meter__how">
        <h2
          class="baloo"
          sharryViewport="fade-in-1">
          {{ 'cherry-meter.how-to-get-cherries' | i18next }}
        </h2>
        <p
          sharryViewport="fade-in-2"
          [innerHTML]="'cherry-meter.cherry-actions' | i18next"></p>
        <div
          class="cherry-meter__how__data"
          sharryViewport="fade-in-2">
          <p class="cherry-meter__how__data--next-goal baloo">{{ 'cherry-meter.next-goal' | i18next }}</p>
          <p class="cherry-meter__how__data--cherries">
            <strong>{{ user ? user.totalCherries % 100 : 0 }} {{ 'cherry-meter.cherries' | i18next }}</strong>
            {{ 'cherry-meter.on-100' | i18next }}
          </p>
          <div class="cherry-meter__how__data--bar">
            <div [style]="'--progressWidth:' + (user ? user.totalCherries % 100 : 0) + '%;'"></div>
            <span></span>
          </div>
        </div>
        <sharry-scrollable-elements [customTemplate]="templateCards">
          <ng-template #templateCards>
            <div class="cherry-meter__how__cards">
              <!--sharryViewport="fade-in-3"-->
              @for (card of cards; track card) {
                <div class="cherry-meter__how__cards--card">
                  <span>
                    <sharry-icon
                      svgClass="svg-icon"
                      [type]="card.type"
                      [name]="card.icon"></sharry-icon>
                  </span>
                  <p
                    class="cherry-meter__how__cards--card--desc"
                    [innerHTML]="card.text | i18next"></p>
                  <div class="cherry-meter__how__cards--card--cherries">
                    <strong class="baloo"
                      >+{{ card.amount }}
                      {{
                        card.amount > 1 ? ('cherry-meter.cherries' | i18next) : ('cherry-meter.cherry' | i18next)
                      }}</strong
                    >
                    <img
                      width="45"
                      height="56"
                      src="https://media.sharry.land/app/images/ciliegiometro/ciliegiometro-animated.svg"
                      alt="cherry" />
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </sharry-scrollable-elements>
        <p [innerHTML]="'cherry-meter.do-you-know-why' | i18next"></p>
        <div class="cherry-meter__how__info">
          <div
            class="cherry-meter__how__info--box"
            sharryViewport="fade-in">
            <h3 class="baloo">{{ 'cherry-meter.more-cherries' | i18next }}</h3>
            <p [innerHTML]="'cherry-meter.using-discounts' | i18next"></p>
          </div>
          <div
            class="cherry-meter__how__info--box"
            sharryViewport="fade-in-1">
            <h3 class="baloo">{{ 'cherry-meter.more-cherries-2' | i18next }}</h3>
            <p [innerHTML]="'cherry-meter.number-one' | i18next"></p>
          </div>
          <div
            class="cherry-meter__how__info--box"
            sharryViewport="fade-in-2">
            <h3 class="baloo">{{ 'cherry-meter.more-value' | i18next }}</h3>
            <p [innerHTML]="'cherry-meter.every-action' | i18next"></p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Ranking -->
  <section class="cherry-meter__ranking-container">
    <section class="cherry-meter__ranking">
      <div class="cherry-meter__ranking__text">
        <h2>
          {{ 'explore.ranking.title' | i18next }}
        </h2>
        <h3>
          {{ 'explore.ranking.subtitle' | i18next }}
        </h3>
        <section
          class="is-not-mobile"
          style="display: contents">
          <p
            class="bigger"
            [innerHTML]="'explore.ranking.text' | i18next"></p>
        </section>
      </div>
      <div class="cherry-meter__ranking__ranks">
        @if (homepageRanking$ | async; as homepageRanking) {
          <div class="cherry-meter__rank">
            <ng-container
              [ngTemplateOutlet]="rankingTemplate"
              [ngTemplateOutletContext]="{ item: homepageRanking.wonder }"></ng-container>
            <ng-container
              [ngTemplateOutlet]="rankingTemplate"
              [ngTemplateOutletContext]="{ item: homepageRanking.sharry }"></ng-container>
            <ng-container
              [ngTemplateOutlet]="rankingTemplate"
              [ngTemplateOutletContext]="{ item: homepageRanking.event }"></ng-container>
            <ng-container
              [ngTemplateOutlet]="rankingTemplate"
              [ngTemplateOutletContext]="{ item: homepageRanking.sharrylander }"></ng-container>
            <ng-template
              #rankingTemplate
              let-item="item">
              <a
                class="cherry-meter__rank__content"
                [routerLink]="item | slug">
                <img
                  fetchpriority="low"
                  alt="cover"
                  class="cherry-meter__rank__content--image"
                  [src]="
                    item.__typename === 'User'
                      ? item?.image?.url || 'https://media.sharry.land/app/images/image-placeholder.webp'
                      : item?.coverPicture?.bestVersion?.url ||
                        'https://media.sharry.land/app/images/image-placeholder.webp'
                  "
                  [ngClass]="{ 'cherry-meter__rank__content--user': item.__typename === 'User' }" />
                @if (item?.__typename !== 'User') {
                  <div class="cherry-meter__rank__text--{{ item.contentType }}">
                    <p
                      class="semibold"
                      sharryEllipsisTooltip="1">
                      {{ item?.title }}
                    </p>
                    <small sharryEllipsisTooltip="1">{{ item?.shortAddress }}</small>
                  </div>
                }
                @if (item?.__typename === 'User') {
                  <div class="cherry-meter__rank__text--user">
                    <p
                      class="semibold"
                      sharryEllipsisTooltip="1">
                      {{ item | userName }}
                    </p>
                    <small sharryEllipsisTooltip="1">{{ item?.workAddress }}</small>
                  </div>
                }
                <div class="cherry-meter__rank__cherries">
                  <p class="baloo">{{ item.totalCherries }}</p>
                  <img
                    fetchpriority="low"
                    width="50"
                    height="50"
                    alt="ciliegia"
                    [src]="'https://media.sharry.land/app/images/ciliegiometro/icona-ciliegiometro.webp'" />
                </div>
              </a>
            </ng-template>
          </div>
        } @else {
          <sharry-loading></sharry-loading>
        }
      </div>
      <section
        class="is-mobile"
        style="display: contents">
        <div class="cherry-meter__ranking__text">
          <p
            class="bigger"
            [innerHTML]="'explore.ranking.text' | i18next"></p>
        </div>
      </section>
    </section>
  </section>
  <div
    class="cherry-meter__play-with-us"
    sharryViewport="fade-in-1">
    <p [innerHTML]="'cherry-meter.play-with-us' | i18next"></p>
    <img
      src="https://media.sharry.land/app/images/cherry-meter/spaceship.png"
      alt="spaceship"
      sharryViewport="fade-in-2" />
  </div>
</div>

<sharry-footer class="is-not-mobile"></sharry-footer>
